module.exports = __webpack_public_path__ + "b899fafbe1a65855295795558af33bbb.svg";